import React from 'react';
import { ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon } from 'lucide-react';
export function TrustBadges() {
  return <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-4 text-xs sm:text-sm text-carbon-400 font-mono mt-8" data-id="element-273">
      <div className="flex items-center gap-2" data-id="element-274">
        <ShieldCheckIcon className="w-4 h-4 text-electric" data-id="element-275" />
        <span className="uppercase tracking-wider" data-id="element-276">Garantía 7 días</span>
      </div>
      <div className="flex items-center gap-2" data-id="element-277">
        <LockIcon className="w-4 h-4 text-electric" data-id="element-278" />
        <span className="uppercase tracking-wider" data-id="element-279">Pago seguro</span>
      </div>
      <div className="flex items-center gap-2" data-id="element-280">
        <ZapIcon className="w-4 h-4 text-electric" data-id="element-281" />
        <span className="uppercase tracking-wider" data-id="element-282">Acceso inmediato</span>
      </div>
      <div className="flex items-center gap-2" data-id="element-283">
        <CreditCardIcon className="w-4 h-4 text-electric" data-id="element-284" />
        <span className="uppercase tracking-wider" data-id="element-285">
          Tarjeta / PayPal / Transf.
        </span>
      </div>
    </div>;
}